/* pm-pdp.js: shared behaviour for the native Primal Muscle product pages (pm-pdp-* sections).
   Smooth scroll to the packages, carousels, Subscribe & Save per package card, add to cart -> /cart. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    // Order Now buttons scroll to the packages
    document.querySelectorAll('.pmx .pmx-go').forEach(function (a) {
      a.addEventListener('click', function (e) { var t = document.getElementById('planArea'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } });
    });
    // carousels (reviews, ingredients)
    document.querySelectorAll('.pmx [data-car]').forEach(function (car) {
      var track = car.querySelector('.pmx-car__track'), slides = [].slice.call(track.children), dots = car.querySelector('[data-dots]');
      var prev = car.querySelector('[data-prev]'), next = car.querySelector('[data-next]'), timer;
      function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
      function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
      function pages() { return Math.max(1, slides.length - perView() + 1); }
      function idx() { return Math.round(track.scrollLeft / step()); }
      function go(i) { var n = pages(); i = (i + n) % n; track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
      function sync() {
        var i = idx(), n = pages();
        if (dots) {
          if (dots.children.length !== n) {
            dots.innerHTML = '';
            for (var k = 0; k < n; k++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (k + 1)); (function (k) { b.onclick = function () { stop(); go(k); }; })(k); dots.appendChild(b); }
          }
          [].forEach.call(dots.children, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        }
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= n - 1;
      }
      function stop() { clearInterval(timer); }
      if (prev) prev.onclick = function () { go(idx() - 1); };
      if (next) next.onclick = function () { go(idx() + 1); };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      track.addEventListener('pointerdown', stop, { passive: true });
      window.addEventListener('resize', sync);
      var auto = +car.getAttribute('data-auto');
      if (auto) timer = setInterval(function () { go(idx() + 1); }, auto);
      sync();
    });
    // Subscribe & Save on any package card: swap the shown price and total, like the original Recharge widget
    document.querySelectorAll('.pmx [data-rc]').forEach(function (rc) {
      var card = rc.closest('.pmx-card'), pr = card.querySelector('[data-pr]'), tot = card.querySelector('[data-tot]');
      rc.addEventListener('change', function () {
        [].forEach.call(rc.querySelectorAll('.pmx-rc__o'), function (o) { o.classList.toggle('pmx-rc__o--on', o.querySelector('input').checked); });
        var p = rc.querySelector('input:checked').closest('label').querySelector('.pmx-rc__p').textContent;
        if (pr) pr.textContent = p; if (tot) tot.textContent = p;
      });
      var pop = card.querySelector('.pmx-rc__pop'), pb = pop && pop.querySelector('.pmx-rc__pb');
      if (pb) pb.addEventListener('click', function () { var o = pop.classList.toggle('is-open'); pb.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    });
    // add to cart: the card's variant (with its selling plan when Subscribe & Save is picked), then /cart like the original
    document.querySelectorAll('.pmx .pmx-atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        var item = { id: +btn.getAttribute('data-variant'), quantity: 1 };
        var rc = btn.closest('.pmx-card').querySelector('[data-rc]'), sel = rc ? rc.querySelector('input:checked') : null;
        if (sel && sel.value !== 'onetime') item.selling_plan = +sel.value;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); window.location.href = '/cart'; })
          .catch(function () { btn.removeAttribute('aria-busy'); alert('Sorry, something went wrong adding this to your cart. Please try again.'); });
      });
    });
    // optional Meta ViewContent, as the original page fired it (set per product in the packages section)
    var vc = document.querySelector('.pmx [data-fbq-vc]');
    if (vc) setTimeout(function () {
      if (typeof fbq === 'function') fbq('track', 'ViewContent', { content_ids: [vc.getAttribute('data-fbq-vc')], content_type: 'product', value: +vc.getAttribute('data-fbq-value'), currency: 'USD' });
    }, 1000);
  });
})();
